"use strict";
const React = require('react');
exports.Row = (props) => React.createElement("div", {style: Object.assign({ display: 'flex', flexDirection: 'row' }, props.style)}, props.children);
exports.Column = (props) => React.createElement("div", {style: Object.assign({ display: 'flex', flexDirection: 'column' }, props.style)}, props.children);



/** WEBPACK FOOTER **
 ** ./src/components/Flex.tsx
 **/